import "./assets/less/main.less";
import "./assets/less/uistruct.less";

import { createApp } from "vue";
import App from "./App.vue";
import router, { pathRequiresAuth } from "./router";
import { Skapi } from "skapi-js";
import type {
    // BinaryFile,
    // Condition,
    // Connection,
    // ConnectionInfo,
    // DatabaseResponse,
    // DelRecordQuery,
    // FetchOptions,
    // FileInfo,
    // Form,
    // GetRecordQuery,
    // Index,
    // Newsletter,
    // PostRecordConfig,
    // ProgressCallback,
    // RealtimeCallback,
    // RecordData,
    // RTCConnector,
    // RTCConnectorParams,
    // RTCEvent,
    // RTCReceiverParams,
    // RTCResolved,
    // Subscription,
    // Table,
    // Tag,
    // UniqueId,
    // UserAttributes,
    UserProfile,
    // UserPublic,
    // WebSocketMessage,
} from "skapi-js";

import { initUser, userLoginCallback, maybeReauthMcp } from "./code/user";
import { version as APP_VERSION } from "../package.json";

let autoLogin = window.sessionStorage.getItem("dont_remember") !== "true";

const SERVICE_ID = import.meta.env.VITE_ADMIN;
const ETC_CONFIG = JSON.parse(import.meta.env.VITE_ETC);
let appMounted = false;

// build date
console.log("deploy:" + import.meta.env.VITE_DATE);
console.log("version:" + APP_VERSION);

// 이미 마운트된 앱이 있으면 먼저 언마운트
// HMR(Hot Module Replacement)로 인해 main.ts가 재로드될 때 새로운 앱 인스턴스가 생성되면서 기존에 마운트된 앱 위에 다시 마운트하려고 시도하는 문제를 방지
// 개발 환경에서 빌링 페이지 갔다가 브라우저 뒤로가기 했을 때 에러 발생 문제 해결
const existingApp =
    document.querySelector("#app")?.__vue_app__;
if (existingApp) {
    existingApp.unmount();
}

export const app = createApp(App);


let previousUserId = "";

export const onLoginHanger:{[id:string]: Function} = {}

export const skapi = new Skapi(
    SERVICE_ID,
    "skapi",
    {
        requestBatchSize: 50,
        autoLogin,
        eventListener: {
            // onBatchProcess: (b) => console.log("Batch Process:", b),
            onUserUpdate: (user:UserProfile) => {
                initUser(user);
            },
            onLogin: async (user:UserProfile) => {
                // console.log("User logged in:", user);
                if (!user) {
                    skapi.util.terminatePendingRequests();
                }

                if (!appMounted) {
                    // Pre-mount MCP gate. If the user deep-linked straight into
                    // a login-gated route with a stale MCP session, run the
                    // OAuth round-trip BEFORE the first paint so the journey is
                    // blank -> MCP login -> intended page, never a flash of the
                    // app followed by a surprise bounce. Public routes (landing,
                    // /login, /signup, ...) skip this and mount immediately.
                    if (user && pathRequiresAuth(window.location.pathname)) {
                        const redirecting = await maybeReauthMcp(user);
                        if (redirecting) return; // browser leaving the SPA; don't mount
                    }

                    app.use(router);
                    app.mount("#app");

                    appMounted = true;
                }
                
                for(let k in onLoginHanger) {
                    try {
                        onLoginHanger[k](user);
                    } catch(err) {
                        console.error(`Error in onLoginHanger ${k}:`, err);
                    }
                    delete onLoginHanger[k];
                }

                if(previousUserId === (user?.user_id || "")) {
                    // console.log("Same user logged in, skipping onLogin callback.");
                    return;
                }

                previousUserId = user?.user_id || "";

                userLoginCallback(user);
            },
        },
    },
    ETC_CONFIG,
);

skapi.version();

export const ENDPOINTS = (async () => {
    let endpoints = await Promise.all([
        skapi.admin_endpoint,
        skapi.record_endpoint,
    ]);
    let admin_private_endpoint = endpoints[0].admin_private; // https://.../
    let admin_public_endpoint = endpoints[0].admin_public; // https://.../
    let record_private_endpoint = endpoints[1].record_private; // https://.../
    let record_public_endpoint = endpoints[1].record_public; // https://.../
    let ep = {
        admin_private_endpoint,
        admin_public_endpoint,
        record_private_endpoint,
        record_public_endpoint,
    };
    return ep;
})();

import("./error_handler");

